(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('ScheduledJobDeleteController',ScheduledJobDeleteController);

    ScheduledJobDeleteController.$inject = ['$uibModalInstance', 'entity', 'ScheduledJob'];

    function ScheduledJobDeleteController($uibModalInstance, entity, ScheduledJob) {
        var vm = this;

        vm.scheduledJob = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	ScheduledJob.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
